import React, { useState, useEffect } from "react";
import axios from "axios";
import Table_4 from "../Tables/Table_4";
import { useAuth } from "../../context/AuthContext";
import "../../styles/InfoCard.css"; // InfoCard 스타일 재사용

const InfoCardStaffOnly = ({
  Server_IP,
  comName,
  setComName,
  setUserId,
  orderBookReset,
  setResetInfoCard,
  clientQuery,
  setClientQuery,
  setClientListFromParent,
}) => {
  const [clientList, setClientList] = useState([]);
  const { token, userType, userId, managerName, managerEmail } = useAuth();

  useEffect(() => {
    getClientList(Server_IP, token, setClientList);
  }, []);

  // 부모 컴포넌트로 clientList 전달
  useEffect(() => {
    if (setClientListFromParent) {
      setClientListFromParent(clientList);
    }
  }, [clientList, setClientListFromParent]);

  const getClientList = async (Server_IP, token, setClientList) => {
    try {
      const { data } = await axios.post(
        `${Server_IP}/api/getClientList/`,
        {}, // 본문은 없으면 빈 객체
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setClientList(data);
    } catch (error) {
      console.log("getClientList 에러:", error);
      setClientList([]); // 실패 시 안전하게 빈 배열 설정
    }
  };

  return (
    <>
      <div className="staff-info-card modern" style={{ marginTop: "16px" }}>
        <div className="client-info">
          <div className="info-row">
            <span className="label">회사선택</span>
            <div className="radio-group modern">
              {["M", "T"].map((mode) => (
                <button
                  key={mode}
                  className={`mode-button ${comName === mode ? "active" : ""}`}
                  onClick={() => setComName(mode)}
                >
                  {mode}
                </button>
              ))}
            </div>
          </div>

          <div className="table-container nomargin ">
            <div className="client-info nomargin">
              <Table_4
                Server_IP={Server_IP}
                token={token}
                clientList={clientList}
                setUserId={setUserId}
                orderBookReset={orderBookReset}
                setResetInfoCard={setResetInfoCard}
                clientQuery={clientQuery}
                setClientQuery={setClientQuery}
              />
            </div>
          </div>

          <div className="d-grid mt-3">
            <button
              type="button"
              className="btn btn-dark fw-bold"
              title=""
              aria-label="외부 공지사항 관리"
              onClick={() => {
                const url = `/outboundNoticeManagement?authToken=${encodeURIComponent(
                  token || "",
                )}&userType=${encodeURIComponent(
                  userType || "",
                )}&userId=${encodeURIComponent(userId || "")}&managerName=${encodeURIComponent(
                  managerName || "",
                )}&managerEmail=${encodeURIComponent(managerEmail || "")}`;
                const newWin = window.open(url, "_blank");
                if (newWin) newWin.opener = null;
              }}
            >
              외부 공지사항 관리
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoCardStaffOnly;
